import { addToDataLayer, type DataLayerEvent } from '..';

export type SortUpdateEventType = {
  value: string;
  products: number;
};

export function addSortInteractionEventToDataLayer(data: SortUpdateEventType) {
  const ga4Event: DataLayerEvent = {
    event: 'sort_interaction',
    event_info: {
      sort_value: data.value,
      sort_products: data.products,
    },
  };
  addToDataLayer(ga4Event);
}
